export default "__VITE_ASSET__DK$z8S_D__"